module.exports = __webpack_public_path__ + "no-data.svg";